
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';

//export enum DateRangeTypes { Daily = "Daily", Weekly = "Weekly", Monthly = "Monthly", TwoMonths = "Two Months", ThreeMonths = "Three Months", Yearly = "Yearly", Custom = "Custom" };
export enum DateRangeTypes { Daily = "Daily", Weekly = "Weekly", Monthly = "Monthly" };

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.less']
})

export class DateRangeComponent implements OnInit {
  @Input() dateRangeType: DateRangeTypes | undefined;
  @Input() inputCurrentDate: Date | undefined;
  @Input() readonly: boolean = false;

  // Event Emitteers
  @Output() fromDateEvent = new EventEmitter<Date>();
  @Output() toDateEvent = new EventEmitter<Date>();
  @Output() changePeriodEvent = new EventEmitter<string>();

  // Actual Data
  fromDate: Date = new Date();
  toDate: Date = new Date();

  // Display Data
  pastDate: Date = new Date();
  futureDate: Date = new Date();
  currentDate: Date = new Date();

  pastDateStr: string = '';
  currentDateStr: string = '';
  futureDateStr: string = '';

  forwardDisabled: boolean = false;
  dropDownSelection = DateRangeTypes.Monthly;
  DateRangeType = DateRangeTypes;

  shouldShowRange: boolean = true;

  constructor() {}

  ngOnInit(): void {
    // Initialize dates with inputs if provided, otherwise use current date
    if (this.inputCurrentDate) {
      this.shouldShowRange = true;
      this.currentDate = this.inputCurrentDate ? new Date(this.inputCurrentDate) : new Date();
      this.toDate = this.currentDate;
      this.fromDate = this.currentDate;
      this.pastDate = this.currentDate;
      this.futureDate = this.currentDate;
    }

    this.dropDownSelection = this.dateRangeType ?? DateRangeTypes.Monthly;
    this.changePeriodEvent.emit(this.dropDownSelection);
    this.updateTimeSpan(true);
  }

  // ngOnInit(): void {
  //   this.currentDate = new Date();
  //   this.fromDate = new Date(this.currentDate);
  //   this.toDate = new Date(this.currentDate);
  //   this.futureDate = new Date(this.currentDate);
  //   this.pastDate = new Date(this.currentDate);

  //   this.dropDownSelection = DateRangeTypes.Monthly;
  //   this.changePeriodEvent.emit(this.dropDownSelection);
  //   this.updateTimeSpan();
  // }

  startChange(event: any) {
    let recievedDate = new Date(event.value);
    this.toDate = new Date(recievedDate.getFullYear(), recievedDate.getMonth(), recievedDate.getDate(), 0, 0, 0, 0);
    //this.updateCustom();
    this.updateDatesEvent();
  }

  endChange(event: any) {
    let recievedDate = new Date(event.value);
    this.toDate = new Date(recievedDate.getFullYear(), recievedDate.getMonth(), recievedDate.getDate(), 23, 59, 59, 59);
    //this.updateCustom();
    this.updateDatesEvent();
  }

  // The event to update for the parent.
  updateDatesEvent() {
    this.toDateEvent.emit(this.toDate);
    this.fromDateEvent.emit(this.fromDate);
  }

  selectMenuItem(event: MatSelectChange) {
    this.dropDownSelection = event.value;
    this.changePeriodEvent.emit(this.dropDownSelection);
    this.updateTimeSpan();
  }

  backDate() {
    switch (this.dropDownSelection) {
      case DateRangeTypes.Daily:
        this.currentDate.setDate(this.currentDate.getDate() - 1);
        this.updateDaily();
        break;

      case DateRangeTypes.Weekly:
        this.currentDate.setDate(this.currentDate.getDate() - 7);
        this.updateWeekly();
        this.updateDatesEvent();
        break;

      case DateRangeTypes.Monthly:
        this.currentDate.setMonth(this.currentDate.getMonth() - 1);
        this.updateMonthly(1);
        this.updateDatesEvent();
        break;

    //   case DateRangeTypes.TwoMonths:
    //     this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    //     this.updateMonthly(2);
    //     this.updateDatesEvent();
    //     break;

    //   case DateRangeTypes.ThreeMonths:
    //     this.currentDate.setMonth(this.currentDate.getMonth() - 1);
    //     this.updateMonthly(3);
    //     this.updateDatesEvent();
    //     break;

    //   case DateRangeTypes.Yearly:
    //     this.currentDate.setFullYear(this.currentDate.getFullYear() - 1);
    //     this.updateYearly();
    //     this.updateDatesEvent();
    //     break;
    }
  }

  forwardDate() {
    if (this.forwardDisabled) {
      return;
    }

    switch (this.dropDownSelection) {
      case DateRangeTypes.Daily:
        this.currentDate.setDate(this.currentDate.getDate() + 1);
        this.updateDaily();
        break;

      case DateRangeTypes.Weekly:
        this.currentDate.setDate(this.currentDate.getDate() + 7);
        this.updateWeekly();
        this.updateDatesEvent();
        break;

      case DateRangeTypes.Monthly:
        this.currentDate.setMonth(this.currentDate.getMonth() + 1);
        this.updateMonthly(1);
        this.updateDatesEvent();
        break;

      // case DateRangeTypes.TwoMonths:
      //   this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      //   this.updateMonthly(2);
      //   this.updateDatesEvent();
      //   break;

      // case DateRangeTypes.ThreeMonths:
      //   this.currentDate.setMonth(this.currentDate.getMonth() + 1);
      //   this.updateMonthly(3);
      //   this.updateDatesEvent();
      //   break;

      // case DateRangeTypes.Yearly:
      //   this.currentDate.setFullYear(this.currentDate.getFullYear() + 1);
      //   this.updateYearly();
      //   this.updateDatesEvent();
      //   break;
    }
  }

  updateTimeSpan(initOverride: boolean = false) {
    this.shouldShowRange = true;
    if (!initOverride) this.currentDate = new Date();

    switch (this.dropDownSelection) {

      case DateRangeTypes.Daily:
        this.updateDaily();
        break;
      case DateRangeTypes.Weekly:
        this.updateWeekly();
        this.updateDatesEvent();
        break;
      case DateRangeTypes.Monthly:
        this.updateMonthly(1);
        this.updateDatesEvent();
        break;
      // case DateRangeTypes.TwoMonths:
      //   this.updateMonthly(2);
      //   this.updateDatesEvent();
      //   break;

      // case DateRangeTypes.ThreeMonths:
      //   this.updateMonthly(3);
      //   this.updateDatesEvent();
      //   break;

      // case DateRangeTypes.Yearly:
      //   this.updateYearly();
      //   this.updateDatesEvent();
      //   break;

      // case DateRangeTypes.Custom:
      //   this.updateCustom();
      //   this.updateDatesEvent();
      //   //console.log("PING");
      //   break;
    }

    //this.updateDatesEvent();
  }

  // updateCustom() {
  //   this.shouldShowRange = false;
  //   this.currentDateStr = "";
  // }

  updateDaily() {
    this.fromDate = new Date(this.currentDate.getTime());
    this.fromDate.setHours(0, 0, 0, 0);

    this.toDate = new Date(this.fromDate.getTime());
    this.toDate.setHours(23, 59, 59, 999);

    this.toDateEvent.emit(this.toDate);
    this.fromDateEvent.emit(this.fromDate);

    this.pastDate = this.fromDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() - 1, 0, 0, 0, 0);
    this.futureDate = this.fromDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate() + 1, 0, 0, 0, 0);

    this.pastDateStr = "< " + this.pastDate.getDate() + " " + this.pastDate.toLocaleString('default', { month: 'short' }) + " " + this.pastDate.getFullYear();
    this.currentDateStr = this.currentDate.getDate() + " " + this.currentDate.toLocaleString('default', { month: 'short' }) + " " + this.currentDate.getFullYear();
    this.futureDateStr = this.futureDate.getDate() + " " + this.futureDate.toLocaleString('default', { month: 'short' }) + " " + this.futureDate.getFullYear() + " >";

    let now = new Date();
    if (this.futureDate > now) {
      this.forwardDisabled = true;
    } else {
      this.forwardDisabled = false;
    }

  }

  updateWeekly() {
    this.fromDate = new Date(this.currentDate);
    this.toDate = new Date(this.currentDate);

    // Get the begining of the week.
    let fromDay = this.fromDate.getDate() - this.currentDate.getDay();
    this.fromDate = new Date(this.fromDate.getFullYear(), this.fromDate.getMonth(), fromDay, 0, 0, 0, 0);

    this.toDate = new Date(this.fromDate);
    let toDay = this.toDate.getDate() + 6;
    this.toDate = new Date(this.toDate.getFullYear(), this.toDate.getMonth(), toDay, 23, 59, 59, 59);

    this.pastDateStr = "<<";
    this.currentDateStr = this.fromDate.getDate() + " " + this.fromDate.toLocaleString('default', { month: 'short' }) + " " + this.fromDate.getFullYear() + " - " + this.toDate.getDate() + " " + this.toDate.toLocaleString('default', { month: 'short' }) + " " + this.toDate.getFullYear();;
    this.futureDateStr = ">>";

    this.updateFutureButtonWeek()
  }

  updateMonthly(months: any) {
    this.fromDate = new Date(this.currentDate);
    this.toDate = new Date(this.currentDate);

    if (months > 1) {

      this.fromDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - months + 1, 1, 0, 0, 0, 0);
      this.toDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0, 23, 59, 59, 59);

      this.futureDate = new Date(this.toDate);
      this.futureDate.setMonth(this.futureDate.getMonth() + 1);

      // Showing next range could be messy. << & >> do look pretty good...
      this.pastDateStr = "<<";
      this.currentDateStr = this.fromDate.toLocaleString('default', { month: 'long' }) + " " + this.fromDate.getFullYear() + " - " + this.toDate.toLocaleString('default', { month: 'long' }) + " " + this.toDate.getFullYear();;
      this.futureDateStr = ">>";

    } else {

      this.fromDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1, 0, 0, 0, 0);
      this.toDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0, 23, 59, 59, 59);

      this.futureDate = new Date(this.toDate);
      this.futureDate.setDate(1);
      this.futureDate.setMonth(this.futureDate.getMonth() + 1);

      this.pastDate = new Date(this.fromDate);
      this.pastDate.setMonth(this.pastDate.getMonth() - 1);

      this.pastDateStr = "< " + this.pastDate.toLocaleString('default', { month: 'short' }) + " " + this.pastDate.getFullYear();
      this.currentDateStr = this.currentDate.toLocaleString('default', { month: 'short' }) + " " + this.currentDate.getFullYear();
      this.futureDateStr = this.futureDate.toLocaleString('default', { month: 'short' }) + " " + this.futureDate.getFullYear() + " >";
    }

    this.updateFutureButtonMonth();
  }

  // updateYearly() {
  //   this.fromDate = new Date(this.currentDate.getFullYear(), 0, 1, 0, 0, 0, 0);
  //   this.toDate = new Date(this.currentDate.getFullYear(), 12, 0, 23, 59, 59, 59);

  //   this.futureDate = new Date(this.toDate);
  //   this.futureDate.setFullYear(this.futureDate.getFullYear() + 1);

  //   this.pastDate = new Date(this.fromDate);
  //   this.pastDate.setFullYear(this.pastDate.getFullYear() - 1);

  //   this.pastDateStr = "< " + this.pastDate.getFullYear();
  //   this.currentDateStr = this.currentDate.getFullYear().toString();
  //   this.futureDateStr = this.futureDate.getFullYear() + " >";

  //   let now = new Date();
  //   if (this.futureDate.getFullYear() > now.getFullYear()) {
  //     this.forwardDisabled = true;
  //   } else {
  //     this.forwardDisabled = false;
  //   }
  // }

  // Check if the future button should be disabled.
  updateFutureButtonWeek() {
    let userCurrentTime = new Date();
    let dateDifference = this.toDate.getDate() - userCurrentTime.getDate();

    // If in the same month
    if (this.toDate.getMonth() == userCurrentTime.getMonth() && this.toDate.getFullYear() == userCurrentTime.getFullYear()) {

      if (dateDifference < 7 && dateDifference >= 0) {
        this.forwardDisabled = true;
      } else {
        this.forwardDisabled = false;
      }
    } else {
      if (dateDifference < 0 || dateDifference > 7) {
        this.forwardDisabled = false;
      }
    }
  }

  updateFutureButtonMonth() {
    let now = new Date();
    if (now.getMonth() < this.futureDate.getMonth() && now.getFullYear() <= this.futureDate.getFullYear()) {
      this.forwardDisabled = true;
    } else {
      this.forwardDisabled = false;
    }
  }
}
